import { Modal } from 'antd';
import React from 'react';
import ExcelS3Upload from './ExcelS3Upload/ExcelS3Upload';

export interface BulkUploadShipmentProps<T> {
  isVisible: boolean;
  title: string;
  okText: string;
  isLoading: boolean;
  headerTextExcelUpload: string;
  sampleLinkInfoText: string;
  showErrorHtml: boolean;
  isMultiple: boolean;
  handleOnCancel: () => void;
  handleSubmit: () => void;
  handleSampleDownloadLink: () => void;
  handlleFileData: (data: T) => void;
  handleRemoveFile: () => void;
  errorHtml?: React.ReactNode | React.ReactNode[];
  children?: React.ReactNode | React.ReactNode[];
}

function SEBulkExcelUpdate<T = any>(props: BulkUploadShipmentProps<T>) {
  const {
    headerTextExcelUpload,
    isVisible,
    title,
    okText,
    isLoading,
    sampleLinkInfoText,
    showErrorHtml,
    errorHtml,
    children,
    isMultiple,
    handleOnCancel,
    handleSubmit,
    handlleFileData,
    handleRemoveFile,
    handleSampleDownloadLink,
  } = props;

  return (
    <div style={{width:'100%', height:'100%', display:'flex', justifyContent:'center'}}>
      <div style={{ width: '70%', height: '100%' , padding: '50px'}}>
        {children}
        <ExcelS3Upload
          headerText={headerTextExcelUpload}
          fileType={'excel'}
          isMultiple={isMultiple}
          accept={'.xlsx, .xls'}
          onDataLoaded={handlleFileData}
          sampleLinkDownload={handleSampleDownloadLink}
          sampleLinkInfoText={sampleLinkInfoText}
          removeFile={handleRemoveFile}
        />
        {(() => {
          if (showErrorHtml && errorHtml) {
            return <>{errorHtml}</>;
          }
          return null;
        })()}
      </div>
    </div>
  );
}

export default SEBulkExcelUpdate;
